import React, {useState, useEffect} from 'react';
import {CIcon} from '@coreui/icons-react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import {Bar} from 'react-chartjs-2';
import {getApi} from "../apis/backendApis";
import formatDate from "./formatDate";
import {stylesImpressaoRetrospectivaCSS} from "../scss/impressaoRelatorioRetrospectivaCSS";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export const ImpressaoRelatorioRetrospectiva = () => {
    const [activeTab, setActiveTab] = useState('overview');
    const [selectedSprint, setSelectedSprint] = useState('both');
    const [dados, setDados] = useState<any>(null);

    useEffect(() => {
        const id = window.location.href.split('/').pop();
        const api = getApi();
        api
            .get(`relatorio-retrospectiva/get/${id}`)
            .then((response: any) => setDados(response.data))
            .catch((err: any) => console.error('Erro ao buscar relatório:', err));
    }, []);

    if (!dados)
        return (
            <div style={stylesImpressaoRetrospectivaCSS.loaderContainer as React.CSSProperties}>
                <div style={stylesImpressaoRetrospectivaCSS.loaderDotsRow as React.CSSProperties}>
                    <div style={stylesImpressaoRetrospectivaCSS.dot() as React.CSSProperties}/>
                    <div style={stylesImpressaoRetrospectivaCSS.dot('0.2s') as React.CSSProperties}/>
                    <div style={stylesImpressaoRetrospectivaCSS.dot('0.4s') as React.CSSProperties}/>
                </div>
                <style>{stylesImpressaoRetrospectivaCSS.keyframes}</style>
            </div>
        );

    const TabButton = ({id, label, icon}: any) => (
        <button onClick={() => setActiveTab(id)} style={stylesImpressaoRetrospectivaCSS.tabButton(activeTab === id)}>
            <CIcon name={icon}/>
            <span>{label}</span>
        </button>
    );

    const renderResumo = () => {
        const sprints = filterBySelectedSprint();

        const chartLabels =
            sprints.map((info: any) => info.versao[0]?.sprintName || 'Sprint')

        const chartDatasets =
             [
                    {
                        label: 'Desenvolvimento',
                        data: sprints.map((info: any) => info.sprintData.totalAtividadesDev),
                        backgroundColor: '#82ca9d',
                    },
                    {
                        label: 'Qualidade',
                        data: sprints.map((info: any) => info.sprintData.totalAtividadesQA),
                        backgroundColor: '#ffc658',
                    },
                ]

        return (
            <div>
                {sprints.map((info: any, i: number) => {
                    const sprintName = info.versao[0]?.sprintName || `Sprint ${i + 1}`;
                    const {sprintData} = info;

                    return (
                        <div key={i} style={stylesImpressaoRetrospectivaCSS.sprintOuterCard as React.CSSProperties}>
                            <h3 style={stylesImpressaoRetrospectivaCSS.sprintTitle as React.CSSProperties}>{sprintName}</h3>

                            <div style={stylesImpressaoRetrospectivaCSS.grid as React.CSSProperties}>
                                <div style={stylesImpressaoRetrospectivaCSS.card as React.CSSProperties} >
                                    <h4 style={stylesImpressaoRetrospectivaCSS.cardTitle as React.CSSProperties}>Prazo</h4>
                                    <p style={stylesImpressaoRetrospectivaCSS.cardValue as React.CSSProperties}>
                                        {info.data_prevista >= info.data_efetiva ? (
                                            <span style={stylesImpressaoRetrospectivaCSS.statusRow('green') as React.CSSProperties}>
                                                <CIcon name="cilCheckCircle" style={stylesImpressaoRetrospectivaCSS.iconMarginRight as React.CSSProperties}/>
                                                    No Prazo
                                            </span>
                                        ) : (
                                            <span style={stylesImpressaoRetrospectivaCSS.statusRow('red') as React.CSSProperties}>
                                                <CIcon name="cilXCircle" style={stylesImpressaoRetrospectivaCSS.iconMarginRight as React.CSSProperties}/>
                                                    Atraso
                                            </span>
                                        )}
                                    </p>
                                    <small style={stylesImpressaoRetrospectivaCSS.cardSubtitle as React.CSSProperties}>
                                        {formatDate(info.data_prevista)} → {formatDate(info.data_efetiva)}
                                    </small>
                                </div>

                                <div style={stylesImpressaoRetrospectivaCSS.card as React.CSSProperties}>
                                    <h4 style={stylesImpressaoRetrospectivaCSS.cardTitle as React.CSSProperties}>Atividades</h4>
                                    <p style={stylesImpressaoRetrospectivaCSS.cardValue as React.CSSProperties}>{sprintData.totalAtividades}</p>
                                    <small style={stylesImpressaoRetrospectivaCSS.cardSubtitle as React.CSSProperties}>
                                        Dev: {sprintData.totalAtividadesDev} | QA: {sprintData.totalAtividadesQA}
                                    </small>
                                </div>

                                <div style={stylesImpressaoRetrospectivaCSS.card as React.CSSProperties}>
                                    <h4 style={stylesImpressaoRetrospectivaCSS.cardTitle as React.CSSProperties}>Horas</h4>
                                    <p style={stylesImpressaoRetrospectivaCSS.cardValue as React.CSSProperties}>{sprintData.totalHorasGeral.toFixed(1)}h</p>
                                    <small style={stylesImpressaoRetrospectivaCSS.cardSubtitle as React.CSSProperties}>
                                        Est: {sprintData.totalHorasEstimado.toFixed(1)}h
                                    </small>
                                </div>

                                <div style={stylesImpressaoRetrospectivaCSS.card as React.CSSProperties}>
                                    <h4 style={stylesImpressaoRetrospectivaCSS.cardTitle as React.CSSProperties}>Rejeições</h4>
                                    <p style={stylesImpressaoRetrospectivaCSS.cardValue as React.CSSProperties}>{sprintData.totalRejeicoes}</p>
                                    <small style={stylesImpressaoRetrospectivaCSS.cardSubtitle as React.CSSProperties}>
                                        Dev: {sprintData.totalRejeicoesDev} | QA: {sprintData.totalRejeicoesQA}
                                    </small>
                                </div>
                            </div>
                        </div>
                    );
                })}

                {sprints.length > 0 && (
                    <div style={stylesImpressaoRetrospectivaCSS.chartWrapper as React.CSSProperties}>
                        <h4 style={stylesImpressaoRetrospectivaCSS.chartTitle as React.CSSProperties}>
                            Distribuição de Atividades {sprints.length > 1 ? 'por Sprint' : ''}
                        </h4>
                        <Bar
                            data={{labels: chartLabels, datasets: chartDatasets}}
                            options={{responsive: true, plugins: {legend: {position: 'top' as const}}}}
                            height={90}
                        />
                    </div>
                )}
            </div>
        );
    };

    const renderProblemas = () => {
        const sprints = filterBySelectedSprint();

        const sortSprintsByVersion = (sprints: any[]) => {
            return [...sprints].sort((a, b) => {
                const [aMajor, aMinor] = a.versao[0].sprintName.split(".").map(Number);
                const [bMajor, bMinor] = b.versao[0].sprintName.split(".").map(Number);

                if (aMajor !== bMajor) return aMajor - bMajor;
                return aMinor - bMinor;
            });
        };

        const getProblemaReducao = (sprints: any[]) => {
            const ordered = sortSprintsByVersion(sprints);

            if (ordered.length < 2) return { percent: 0, status: "igual" };

            const last = ordered[ordered.length - 1].problemas.length;
            const prev = ordered[ordered.length - 2].problemas.length;

            if (prev === 0 && last === 0) return { percent: 0, status: "igual" };
            if (prev === 0 && last > 0) return { percent: 100, status: "aumento" };

            const diff = last - prev;
            const percent = Math.abs((diff / prev) * 100);

            if (last < prev) return { percent, status: "redução" };
            if (last > prev) return { percent, status: "aumento" };
            return { percent: 0, status: "igual" };
        };

        const { percent, status } = getProblemaReducao(sprints);

        return (
            <div>
                {sprints.map((info: any, i: number) => {
                    const problemasValidos = info.problemas?.filter((p: string) => p && p.trim() !== '') ?? [];
                    if (problemasValidos.length === 0) return null;
                    return (
                        <div
                            className="mb-3"
                            style={stylesImpressaoRetrospectivaCSS.metricsCard as React.CSSProperties}
                            key={i}
                        >
                            <h3>
                                <CIcon className="text-danger mb-2" name="cil-warning" height={25} />
                                Problemas {info.versao[0].sprintName}
                            </h3>

                            {problemasValidos.map((p: string, idx: number) => (
                                <div key={idx} className="mb-2 font-xl">
                                    <CIcon className="mr-2 text-danger" name="cil-warning" />
                                    {p}
                                </div>
                            ))}
                        </div>
                    );
                })}
                <div style={stylesImpressaoRetrospectivaCSS.metricsCard as React.CSSProperties} className="bg-white text-dark text-value-xl rounded-lg shadow-md p-3">
                    <h3 className="text-xl font-semibold mb-4" >Análise de Problemas</h3>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6" >
                        {sprints.map((p: any, i:any) => (
                            <div key={i} className="text-center" >
                                <div style={{
                                    fontSize: '28px',
                                    fontWeight: 700,
                                    color: 'rgba(255,0,0,0.8)',
                                    marginBottom: '4px'
                                }} className="text-3xl font-bold text-red-600">{p.problemas.length}</div>
                                <div style={{ fontSize: '15px', color: '#444' }} className="text-gray-600">Problemas {p.versao[0].sprintName} </div>
                            </div>
                        ))}
                        <div className="text-center mt-4">
                            <div
                                style={{
                                    fontSize: "22px",
                                    fontWeight: 700,
                                    color:
                                        status === "redução"
                                            ? "green"
                                            : status === "aumento"
                                                ? "red"
                                                : "#444",
                                }}
                            >
                                {status === "igual" ? "Sem variação" : `${percent.toFixed(0)}% ${status}`}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

    )
    };

    const renderDestaques = () => {
        const sprints = filterBySelectedSprint();

        return (
            <div>
                {sprints.map((info: any, i: number) => {
                    if (!info.destaques || info.destaques.length === 0) return null; // ⛔ Não renderiza se vazio

                    return (
                        <div className={'mb-3'} key={i} style={stylesImpressaoRetrospectivaCSS.metricsCard as React.CSSProperties}>
                            <h3>
                                <CIcon className={'text-warning mb-2'} name={'cil-star'} height={25}/>
                                {' '}Destaques {info.versao[0].sprintName}
                            </h3>

                            {info.destaques.map((d: string, idx: number) => (
                                <div className={'mb-2 font-xl'} key={idx}>
                                    <CIcon className={'mr-2 text-success'} name={'cil-check-circle'}/>
                                    {d}
                                </div>
                            ))}
                        </div>
                    );
                })}

                {(() => {
                    const conquistasMaster = dados.dataInfos[0]?.conquistas?.filter((c: any) => c.master) || [];
                    if (conquistasMaster.length === 0) return null; // ⛔ Não renderiza se vazio
                    return (
                        <div className={'mb-3'}
                             style={stylesImpressaoRetrospectivaCSS.metricsCard as React.CSSProperties}>
                            <h3>
                                <CIcon className={'text-primary mb-2'} name={'cil-task'} height={25}/>
                                {' '}Destaques Master
                            </h3>
                            {conquistasMaster.map((c: any, idx: number) => (
                                <div key={idx} className={'mb-2 font-xl'}>
                                    <div style={{color: "#555"}}>
                                        <CIcon className={'mr-2 text-success'} name={'cil-check-circle'}/>
                                        {c.resumo}
                                    </div>
                                </div>
                            ))}
                        </div>
                    );
                })()}

                <div style={stylesImpressaoRetrospectivaCSS.metricsCard as React.CSSProperties}>
                    <h3 style={{ marginBottom: "16px" }}>Principais Conquistas</h3>

                    {dados.dataInfos[0]?.conquistas?.map((c: any, idx: number) => {
                        const bgColors = ["#f0faf4", "#f2f7ff", "#f9f4ff", "#fff9f2"];
                        const textColors = ["#198754", "#0d6efd", "#6f42c1", "#fd7e14"];
                        const bg = bgColors[idx % bgColors.length];
                        const color = textColors[idx % textColors.length];

                        if (!c.master){
                            return (
                                <div key={idx} style={{background: bg, borderRadius: "8px", padding: "24px", marginBottom: "12px", textAlign: "center"}}>
                                    {c.icon && (
                                        <CIcon
                                            name={c.icon}
                                            height={40}
                                            style={{color}}
                                        />
                                    )}
                                    <h5 style={{ fontSize: "19px", margin: "4px 0", color: "#000" }}>{c.titulo}</h5>
                                    <div style={{ fontSize: "17px", color: "#555" }}>
                                        {c.resumo}
                                    </div>
                                </div>
                            );
                        }
                    })}
                </div>
            </div>
        );
    };

    const renderDiscussao = () => {
        const sprints = filterBySelectedSprint();

        const colors = [
            { color: '#0d6efd', bg: '#e9f2ff' },
            { color: '#16a34a', bg: '#ecfdf5' },
            { color: '#9333ea', bg: '#f5f3ff' },
            { color: '#ca8a04', bg: '#fefce8' },
        ];

        return (
            <div className="font-xl" style={stylesImpressaoRetrospectivaCSS.metricsCard as React.CSSProperties}>
                <h3 style={{marginBottom: '16px'}}>Pontos para Discussão</h3>
                {sprints.map((info: any, i: number) => (
                    <div key={i}>
                        {info.discussoes.map((d: any, idx: number) => {
                            const {color, bg} = colors[idx % colors.length];
                            if (d.pergunta === "" && d.contexto === "") return null;
                            return (
                                <div key={idx} style={stylesImpressaoRetrospectivaCSS.discussBox(color, bg)}>
                                    <div style={stylesImpressaoRetrospectivaCSS.discussQuestion(color)}>
                                        {d.pergunta}
                                    </div>
                                    <div style={stylesImpressaoRetrospectivaCSS.discussContext}>
                                        <span style={stylesImpressaoRetrospectivaCSS.discussContextLabel}>
                                            Contexto:
                                        </span>
                                        {d.contexto}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                ))}
            </div>
        );
    };

    const renderMetricas = () => {
        let sprints = filterBySelectedSprint();


        sprints = [...sprints].sort((a: any, b: any) => {
            const parse = (v: string) => v.split('.').map(Number);
            const [a1, a2] = parse(a.versao[0]?.sprintName.replace('Sprint ', ''));
            const [b1, b2] = parse(b.versao[0]?.sprintName.replace('Sprint ', ''));
            return a1 === b1 ? a2 - b2 : a1 - b1;
        });

        const formatPercent = (num: number) => `${num.toFixed(0)}%`;

        const chartLabels = sprints.map((s: any) => s.versao[0]?.sprintName);
        const chartData = {
            labels: chartLabels,
            datasets: [
                {
                    label: 'Horas Estimadas',
                    data: sprints.map((s: any) => s.sprintData.totalHorasEstimado),
                    backgroundColor: 'rgba(13,110,253,0.6)',
                },
                {
                    label: 'Horas Reais',
                    data: sprints.map((s: any) => s.sprintData.totalHorasGeral),
                    backgroundColor: 'rgba(40,167,69,0.6)',
                },
            ],
        };

        return (
            <div style={stylesImpressaoRetrospectivaCSS.metricsContainer as React.CSSProperties}>
                <div style={stylesImpressaoRetrospectivaCSS.metricsCard as React.CSSProperties}>
                    <h3 style={stylesImpressaoRetrospectivaCSS.metricsTitle as React.CSSProperties}>
                        Métricas Gerais de Horas
                    </h3>
                    <Bar
                        data={chartData}
                        options={{ responsive: true, plugins: { legend: { display: false } } }}
                        height={50}
                    />

                    <div style={{ marginTop: '20px' }}>
                        {sprints.map((s: any, i: number) => {
                            const sd = s.sprintData;
                            const summary = [
                                {
                                    value: sd.totalHorasEstimadoDev,
                                    label: `Dev Est.`,
                                    bg: '#e0f2ff',
                                    color: '#0d6efd',
                                },
                                {
                                    value: sd.totalHorasDev,
                                    label: `Dev Real.`,
                                    bg: '#d1fae5',
                                    color: '#28a745',
                                },
                                {
                                    value: sd.totalHorasEstimadoQA,
                                    label: `QA Est.`,
                                    bg: '#f3e8ff',
                                    color: '#6f42c1',
                                },
                                {
                                    value: sd.totalHorasQA,
                                    label: `QA Real.`,
                                    bg: '#fff4e6',
                                    color: '#fd7e14',
                                },
                            ];

                            return (
                                <div key={i} style={{ marginBottom: '24px' }}>
                                    <h4 style={{marginBottom: '12px', fontWeight: 'bold', fontSize: '23px', color: '#333',}}>
                                        Sprint {s.versao[0]?.sprintName}
                                    </h4>

                                    <div style={{display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '12px',}}>
                                        {summary.map((card, i2) => (
                                            <div key={`${i}-${i2}`} style={stylesImpressaoRetrospectivaCSS.summaryItem(card.bg) as React.CSSProperties}>
                                                <div style={stylesImpressaoRetrospectivaCSS.summaryValue(card.color) as React.CSSProperties}>
                                                    {card.value}h
                                                </div>
                                                <div style={stylesImpressaoRetrospectivaCSS.summaryLabel as React.CSSProperties}>
                                                    {card.label}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>

                <div style={stylesImpressaoRetrospectivaCSS.metricsGrid as React.CSSProperties}>
                    {sprints.map((s: any, i: number) => {
                        const sd = s.sprintData;
                        const diffDev = sd.totalHorasEstimadoDev
                            ? ((sd.totalHorasDev - sd.totalHorasEstimadoDev) / sd.totalHorasEstimadoDev) * 100
                            : 0;
                        const diffQA = sd.totalHorasEstimadoQA
                            ? ((sd.totalHorasQA - sd.totalHorasEstimadoQA) / sd.totalHorasEstimadoQA) * 100
                            : 0;

                        const taxaDev = sd.totalAtividadesDev ? (sd.totalRejeicoesDev / sd.totalAtividadesDev) * 100 : 0;
                        const taxaQA = sd.totalAtividadesQA ? (sd.totalRejeicoesQA / sd.totalAtividadesQA) * 100 : 0;

                        let taxaDevIcon = null;
                        let taxaQAIcon = null;
                        let taxaQAPrev = 0;
                        let taxaDevPrev= 0;
                        if (i > 0) {
                            const prev = sprints[i - 1].sprintData;
                             taxaDevPrev = prev.totalAtividadesDev
                                ? (prev.totalRejeicoesDev / prev.totalAtividadesDev) * 100
                                : 0;
                             taxaQAPrev = prev.totalAtividadesQA
                                ? (prev.totalRejeicoesQA / prev.totalAtividadesQA) * 100
                                : 0;

                            taxaDevIcon =
                                taxaDev < taxaDevPrev
                                    ? <CIcon alt={'Melhoria em relação a sprint passada'} className={'text-success'} name={'cil-arrow-bottom'}/>
                                    : taxaDev > taxaDevPrev
                                        ? <CIcon alt={'Pioria em relação a sprint passada'} className={'text-danger'} name={'cil-arrow-top'}/>
                                        : <span style={{ color: '#999' }}></span>;

                            taxaQAIcon =
                                taxaQA < taxaQAPrev
                                    ? <CIcon alt={'Melhoria em relação a sprint passada'} className={'text-success'} name={'cil-arrow-bottom'}/>
                                    : taxaQA > taxaQAPrev
                                        ? <CIcon alt={'Pioria em relação a sprint passada'} className={'text-danger'} name={'cil-arrow-top'}/>
                                        : <span style={{ color: '#999' }}></span>;
                        }

                        return (
                            <div
                                className={'font-xl'}
                                key={i}
                                style={stylesImpressaoRetrospectivaCSS.metricsCard as React.CSSProperties}
                            >
                                <h3 style={stylesImpressaoRetrospectivaCSS.metricsTitle as React.CSSProperties}>
                                    Sprint {s.versao[0]?.sprintName}
                                </h3>
                                <div style={stylesImpressaoRetrospectivaCSS.statRows as React.CSSProperties}>
                                    <div style={stylesImpressaoRetrospectivaCSS.statRow as React.CSSProperties}>
                                        <span>Diferença Desenvolvimento:</span>
                                        <span
                                            style={stylesImpressaoRetrospectivaCSS.statValue(diffDev >= 0 ? 'red' : 'green') as React.CSSProperties}
                                        >
                                        {formatPercent(diffDev)}
                                    </span>
                                    </div>
                                    <div style={stylesImpressaoRetrospectivaCSS.statRow as React.CSSProperties}>
                                        <span>Diferença Qualidade:</span>
                                        <span
                                            style={stylesImpressaoRetrospectivaCSS.statValue(diffQA >= 0 ? 'red' : 'green') as React.CSSProperties}
                                        >
                                        {formatPercent(diffQA)}
                                    </span>
                                    </div>
                                    <div style={stylesImpressaoRetrospectivaCSS.statRow as React.CSSProperties}>
                                        <span>Taxa Retorno Qualidade:</span>
                                        <span
                                            style={stylesImpressaoRetrospectivaCSS.statValue(taxaQA >= 50 ? 'red' : 'green') as React.CSSProperties}
                                        >
                                        {formatPercent(taxaQA)} {taxaQAIcon}
                                    </span>
                                    </div>
                                    <div style={stylesImpressaoRetrospectivaCSS.statRow as React.CSSProperties}>
                                        <span>Taxa Retorno Desenvolvimento:</span>
                                        <span
                                            style={stylesImpressaoRetrospectivaCSS.statValue(taxaDev >= 50 ? 'red' : 'green') as React.CSSProperties}
                                        >
                                        {formatPercent(taxaDev)} {taxaDevIcon}
                                    </span>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    };

    const renderQualidade = () => {
        const sprints = filterBySelectedSprint();
        const formatPercent = (num: number) => `${num.toFixed(0)}%`;

        const chartLabels = sprints.map((s: any) => s.versao[0].sprintName);
        const chartData = {
            labels: chartLabels,
            datasets: [
                {
                    label: 'Taxa Retorno QA',
                    data: sprints.map((s: any) =>
                        s.sprintData.totalAtividadesQA
                            ? (s.sprintData.totalRejeicoesQA / s.sprintData.totalAtividadesQA) * 100
                            : 0
                    ),
                    backgroundColor: 'rgba(111, 66, 193, 0.6)',
                },
                {
                    label: 'Taxa Retorno Dev',
                    data: sprints.map((s: any) =>
                        s.sprintData.totalAtividadesDev
                            ? (s.sprintData.totalRejeicoesDev / s.sprintData.totalAtividadesDev) * 100
                            : 0
                    ),
                    backgroundColor: 'rgba(253, 126, 20, 0.6)',
                },
            ],
        };

        let insightsMelhoria: string[] = [];
        let insightsAtencao: string[] = [];
        let insightsPiora: string[] = [];

        if (sprints.length >= 2) {
            const sorted = [...sprints].sort((a, b) =>
                a.versao[0].sprintName.localeCompare(b.versao[0].sprintName, undefined, { numeric: true })
            );

            const prev = sorted[sorted.length - 2].sprintData;
            const last = sorted[sorted.length - 1].sprintData;

            const taxaQALast = last.totalAtividadesQA
                ? (last.totalRejeicoesQA / last.totalAtividadesQA) * 100
                : 0;
            const taxaQAPrev = prev.totalAtividadesQA
                ? (prev.totalRejeicoesQA / prev.totalAtividadesQA) * 100
                : 0;

            const taxaDevLast = last.totalAtividadesDev
                ? (last.totalRejeicoesDev / last.totalAtividadesDev) * 100
                : 0;
            const taxaDevPrev = prev.totalAtividadesDev
                ? (prev.totalRejeicoesDev / prev.totalAtividadesDev) * 100
                : 0;

            if (taxaQALast < taxaQAPrev) {
                insightsMelhoria.push(
                    `Taxa de retorno de QA reduziu de ${formatPercent(taxaQAPrev)} para ${formatPercent(taxaQALast)}`
                );
            }
            if (taxaDevLast < taxaDevPrev) {
                insightsMelhoria.push(
                    `Taxa de retorno de Dev reduziu de ${formatPercent(taxaDevPrev)} para ${formatPercent(taxaDevLast)}`
                );
            }

            if (taxaQALast > taxaQAPrev) {
                insightsPiora.push(
                    `Taxa de retorno de QA aumentou de ${formatPercent(taxaQAPrev)} para ${formatPercent(taxaQALast)}`
                );
            }
            if (taxaDevLast > taxaDevPrev) {
                insightsPiora.push(
                    `Taxa de retorno de Dev aumentou de ${formatPercent(taxaDevPrev)} para ${formatPercent(taxaDevLast)}`
                );
            }

            if (last.totalHorasEstimado !== last.totalHorasGeral) {
                insightsAtencao.push('Estimativas de horas ainda imprecisas com as horas desenvolvidas');
            }
            if (taxaQALast === taxaQAPrev) {
                insightsAtencao.push(
                    `Taxa de retorno de QA se manteve em ${formatPercent(taxaQALast)}`
                );
            }
            if (taxaDevLast === taxaDevPrev) {
                insightsAtencao.push(
                    `Taxa de retorno de Dev se manteve em ${formatPercent(taxaDevLast)}`
                );
            }
        }

        return (
            <div className="space-y-6 ">
                <div className="rounded-lg shadow-md p-3">
                    <h3 className="text-xl font-semibold mb-4">Taxa de Retorno por Tipo</h3>
                    <Bar
                        data={chartData}
                        options={{
                            responsive: true,
                            plugins: {
                                tooltip: {
                                    callbacks: {
                                        label: (ctx: any) => {
                                            const value = ctx.raw ?? 0;
                                            const label = ctx.dataset.label.includes("QA")
                                                ? `Qualidade: ${value.toFixed(0)

                                                }%`

                                                : `Desenvolvimento: ${value.toFixed(0)
                                                }%`;
                                            return label;
                                        },
                                    }
                                },
                            },
                        }}
                        height={80}
                    />
                </div>
                <div
                    style={stylesImpressaoRetrospectivaCSS.metricsCard as React.CSSProperties}
                    className="font-xl rounded-lg shadow-md mt-3 p-6"
                >
                    <h3 className="text-xl font-semibold mb-4 p-3">Insights de Qualidade</h3>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        <div className="space-y-4 p-3 mb-3"
                             style={stylesImpressaoRetrospectivaCSS.metricsCard as React.CSSProperties}>
                            <h4 className="text-lg font-medium text-green-600">
                                <CIcon className={'text-success mr-2 mb-2'} name={'cil-check-circle'} height={25}/>
                                Melhorias
                            </h4>
                            {insightsMelhoria.length > 0 ? (
                                insightsMelhoria.map((txt, i) => (
                                    <div key={i} className="flex items-center space-x-2 text-sm">
                                        <span>{txt}</span>
                                    </div>
                                ))
                            ) : (
                                <div className="text-gray-500 text-sm">Nenhuma melhoria registrada</div>
                            )}
                        </div>

                        <div className="space-y-4 p-3 mb-3" style={stylesImpressaoRetrospectivaCSS.metricsCard as React.CSSProperties}>
                            <h4 className="text-lg font-medium text-red-600">
                                <CIcon className={'text-danger mr-2 mb-2 '} name={'cil-arrow-bottom'} height={25}/>
                                Pioras
                            </h4>
                                {insightsPiora.length > 0 ? (
                                    insightsPiora.map((txt, i) => (
                                        <div key={i} className="flex items-center space-x-2 text-sm">
                                            <span>{txt}</span>
                                        </div>
                                    ))
                                ) : (
                                    <div className="text-gray-500 text-sm">Nenhuma piora registrada</div>
                                )}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const filterBySelectedSprint = () => {
        if (selectedSprint === 'both') return dados.dataInfos;
        return dados.dataInfos.filter((s: any) => s.versao[0].sprintName === selectedSprint);
    };

    const sprintNames = dados.dataInfos.map((s: any) => s.versao[0].sprintName);

    return (
        <div className={"container"} style={stylesImpressaoRetrospectivaCSS.page as React.CSSProperties}>
            <h1 style={stylesImpressaoRetrospectivaCSS.pageTitle as React.CSSProperties}>Sprint Retrospectiva</h1>

            <div className={'font-xl'} style={stylesImpressaoRetrospectivaCSS.sprintButtonsRow as React.CSSProperties}>
                <button onClick={() => setSelectedSprint('both')}
                        style={stylesImpressaoRetrospectivaCSS.sprintButton(selectedSprint === 'both')}>
                    Todas
                </button>
                {sprintNames.map((name: string) => (
                    <button key={name} onClick={() => setSelectedSprint(name)}
                            style={stylesImpressaoRetrospectivaCSS.sprintButton(selectedSprint === name, '#198754')}>
                        {name}
                    </button>
                ))}
            </div>

            <div className={'font-xl'} style={stylesImpressaoRetrospectivaCSS.tabsRow as React.CSSProperties}>
                <TabButton id="overview" label="Visão Geral" icon={'cilSpeedometer'}/>
                <TabButton id="metrics"  label="Métricas"  icon={'cilChartPie'}/>
                <TabButton id="quality"  label="Qualidade" icon={'cilCheckCircle'}/>
                <TabButton id="problems" label="Problemas" icon={'cilWarning'}/>
                <TabButton id="highlights" label="Destaques" icon={'cilStar'}/>
                <TabButton id="discussion" label="Discussão" icon={'cilSpeech'}/>
            </div>

            <div>
                {activeTab === 'overview' && renderResumo()}
                {activeTab === 'metrics' && renderMetricas()}
                {activeTab === 'quality' && renderQualidade()}
                {activeTab === 'problems' && renderProblemas()}
                {activeTab === 'highlights' && renderDestaques()}
                {activeTab === 'discussion' && renderDiscussao()}
            </div>
        </div>
    );
};

export default ImpressaoRelatorioRetrospectiva;
